import { createAsyncIcon } from '../../_factory/createAsyncIcon';

const AsyncPhosphorIconFill = createAsyncIcon(() => import('./PhosphorIconFill'));

export default AsyncPhosphorIconFill;

AsyncPhosphorIconFill.displayName = 'AsyncPhosphorIconFill';
